<div class="popupmenu">
  <div class="popupmenu-body" [ngClass]="{'popupmenu-body-high-contrast': visualAccessibilityModeOn}">
    <ng-content></ng-content>
  </div>
</div>
<div class="popupmenu-background"></div>
